<span class="td-wb-vh"
      translate="tdWb.menu.UNREAD_MESSAGES"></span>
@if (messagesCounter > 0) {
  <td-wb-badge [number]="messagesCounter"
               [limit]="9"
               size="extra-small"
               colour="accent" />
}
@if (messagesCounter === undefined || messagesCounter === 0) {
  <span class="td-wb-vh">0</span>
}
